@if (!saveAsGenericGroup) {
  <div class="ha-dialog">

    <!-- Header -->
    <div class="ha-header">
      <div class="ha-title-wrap">
        <div class="ha-title-icon">
          <mat-icon>local_florist</mat-icon>
        </div>
        <div class="ha-title-text">
          <h2 class="ha-title">Plan a harvest</h2>
          <div class="ha-subtitle">Set up a grow cycle from a template</div>
        </div>
      </div>
      <button mat-icon-button mat-dialog-close class="ha-close" [disabled]="saveClick" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Batch chip rail -->
    <div class="ha-chiprail">
      @for (hf of harvestFormDataArray; track hf.formId; let i = $index) {
        <button type="button" class="ha-chip"
          [class.on]="i === selectedHarvestTab"
          [class.done]="hf.addSuccess"
          [disabled]="hf.addSuccess"
          (click)="selectedHarvestTab = i">
          <span class="ha-dot" [style.background]="hf.color || '#c9d2cc'"></span>
          <span class="ha-chip-name">{{hf.name && hf.name.length > 0 ? hf.name : 'Untitled harvest'}}</span>
          @if (leaflogixId == null && harvestFormDataArray.length > 1) {
            <mat-icon class="ha-chip-x" (click)="$event.stopPropagation(); deleteHarvestClick(i)">close</mat-icon>
          }
        </button>
      }
      @if (leaflogixId == null) {
        <button id="harvest_tabAdd" type="button" class="ha-chip ha-chip-add" (click)="addHarvestTab()">
          <mat-icon>add</mat-icon>Add harvest
        </button>
      }
    </div>

    <!-- Body -->
    @if (harvestFormDataArray[selectedHarvestTab]; as hf) {
      <form id="addHarvest" class="ha-body" (ngSubmit)="save()">

        <!-- Left: form -->
        <div class="ha-col-form">

          <div class="ha-field">
            <label class="ha-label">Template</label>
            <mat-form-field appearance="outline" class="ha-mat full-width">
              <mat-select [(ngModel)]="hf.selectedTemplate" name="selectedTemplate" (ngModelChange)="templateChange($event, hf.formId)">
                @for (t of hf.templates; track t) {
                  <mat-option [value]="t">{{t.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="ha-field">
            <label class="ha-label">Harvest name <span class="ha-req">*</span></label>
            <mat-form-field appearance="outline" class="ha-mat full-width">
              <input id="harvestAdd-name" matInput placeholder="Name this harvest" type="text" required name="name" [(ngModel)]="hf.name">
            </mat-form-field>
          </div>

          <div class="ha-field">
            <label class="ha-label">Start date</label>
            <mat-form-field appearance="outline" class="ha-mat full-width">
              <input matInput [matDatepicker]="startDatePicker" name="startDate" [(ngModel)]="hf.startDate">
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="ha-field">
            <label class="ha-label">Color label</label>
            <app-color-picker [saveAsGenericGroup]="false" [(color)]="hf.color"></app-color-picker>
          </div>

          @if (allStrains.length > 0 && leaflogixId == null) {
            <div class="ha-field ha-field-last">
              <label class="ha-label">Strains <span class="ha-optional">· optional</span></label>
              <div class="ha-strains">
                <app-strain-select-multiple-for-harvest
                  [(allStrains)]="allStrains"
                  [(strainIds)]="hf.strainIds"
                  [(harvestPhases)]="hf.harvestPhases">
                </app-strain-select-multiple-for-harvest>
                @if (hf.harvestPhases[0] != null && hf.harvestPhases[0].strains?.length > 0) {
                  <div class="ha-strain-list">
                    @for (strain of hf.harvestPhases[0].strains; track strain) {
                      <div class="ha-strain-row">
                        <span class="ha-strain-name">
                          <mat-icon>spa</mat-icon>{{strain.strainName}}
                        </span>
                        <mat-form-field appearance="outline" class="ha-mat ha-count">
                          <input matInput placeholder="Count" type="number" [(ngModel)]="strain.count" [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <!-- Right: grow cycle preview -->
        <aside class="ha-col-cycle">
          <div class="ha-cycle-head">
            <span class="ha-cycle-title">Grow cycle</span>
            @if (hf.harvestDuration) {
              <span class="ha-cycle-badge">{{hf.harvestDuration}} days</span>
            }
          </div>
          <div class="ha-timeline">
            <app-harvest-phase-timeline
              [startDate]="hf.startDate"
              [template]="hf.selectedTemplate"
              (timelineList)="timelineListHandler($event, hf.formId)">
            </app-harvest-phase-timeline>
          </div>
        </aside>
      </form>
    }

    <!-- Footer -->
    <div class="ha-footer">
      <span class="ha-footer-count">
        <mat-icon>layers</mat-icon>
        {{harvestFormDataArray.length}} harvest{{harvestFormDataArray.length === 1 ? '' : 's'}} queued
      </span>
      <div class="ha-footer-actions">
        <button mat-button mat-dialog-close class="ha-btn-ghost" [disabled]="saveClick">Cancel</button>
        <button id="harvestAdd-save" type="submit" form="addHarvest" class="ha-btn-primary" [disabled]="saveClick">
          @if (saveClick) {
            <mat-spinner diameter=20 strokeWidth=3></mat-spinner>
          } @else {
            <span>Review &amp; save</span>
            <mat-icon>arrow_forward</mat-icon>
          }
        </button>
      </div>
    </div>
  </div>
}

@if (saveAsGenericGroup) {
  <div class="ha-dialog">

    <!-- Header -->
    <div class="ha-header">
      <div class="ha-title-wrap">
        <div class="ha-title-icon">
          <mat-icon>checklist</mat-icon>
        </div>
        <div class="ha-title-text">
          <h2 class="ha-title">Create a task group</h2>
          <div class="ha-subtitle">Organize ad-hoc tasks outside a harvest</div>
        </div>
      </div>
      <button mat-icon-button mat-dialog-close class="ha-close" [disabled]="saveClick" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <form id="addHarvest" class="ha-body ha-body-single" (ngSubmit)="save()">
      <div class="ha-col-form">

        <div class="ha-field">
          <label class="ha-label">Group name <span class="ha-req">*</span></label>
          <mat-form-field appearance="outline" class="ha-mat full-width">
            <input id="harvestAdd-name" matInput [placeholder]="namePlaceHolder" type="text" required name="name" [(ngModel)]="name">
          </mat-form-field>
        </div>

        <div class="ha-field">
          <label class="ha-label">Color label</label>
          <app-color-picker [saveAsGenericGroup]="saveAsGenericGroup" [(color)]="color"></app-color-picker>
        </div>

        <div class="ha-field" [class.ha-field-last]="!(selectedSecondaryTemplate && selectedSecondaryTemplate.name !== 'Don\'t Apply Template')">
          <label class="ha-label">Apply a workflow <span class="ha-optional">· optional</span></label>
          <mat-form-field appearance="outline" class="ha-mat full-width">
            <mat-select [(ngModel)]="selectedSecondaryTemplate" name="secondaryTemplate-select" placeholder="No workflow" (selectionChange)="navigateToTemplates($event)">
              @for (secondaryTemplate of secondaryTemplates; track secondaryTemplate) {
                <mat-option [ngClass]="{'full-option-text': secondaryTemplate.name.length > 20}" [value]="secondaryTemplate">
                  {{secondaryTemplate.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (selectedSecondaryTemplate && selectedSecondaryTemplate.name !== 'Don\'t Apply Template') {
          <div class="ha-field ha-field-last">
            <label class="ha-label">Start date</label>
            <mat-form-field appearance="outline" class="ha-mat full-width">
              <input matInput [matDatepicker]="startDatePicker" placeholder="Choose a start date" name="startDate" [(ngModel)]="startDate">
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        }
      </div>
    </form>

    <!-- Footer -->
    <div class="ha-footer ha-footer-end">
      <div class="ha-footer-actions">
        <button mat-button mat-dialog-close class="ha-btn-ghost" [disabled]="saveClick">Cancel</button>
        <button id="harvestAdd-save-group" type="submit" form="addHarvest" class="ha-btn-primary" [disabled]="saveClick">
          @if (saveClick) {
            <mat-spinner diameter=20 strokeWidth=3></mat-spinner>
          } @else {
            <span>Create group</span>
            <mat-icon>check</mat-icon>
          }
        </button>
      </div>
    </div>
  </div>
}
